export const LOTTIE_PLAYER_VERSION = "1.6.2"; 
export const LOTTIE_WEB_VERSION = "^5.10.0";
